import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import LabOffering from "@/pages/LabOffering";

export const Route = createFileRoute("/es/servicios/lab-services/validacion-metodo")({
  head: () => buildRouteHead("/es/servicios/lab-services/validacion-metodo"),
  component: LabOffering,
});

